import { createStore } from 'vuex'
import compState from './Module/compState'
import statistic from './Module/statistic'
import filters from './Module/filterState'
import healthIndex from './Module/healthIndex'
export default createStore({
  modules: {
    compState,
    statistic,
    healthIndex,
    filters
  }
})
